// extracted by mini-css-extract-plugin
export var parcelRow = "_tn-0";